import React, { useEffect, useRef, useState, useCallback } from 'react'
import { BASE_URL, CART_COUNT_URL, TECHNICAL_CATEGORY_URL, PROFILE_INFO_URL } from '../constants/Url'
import httpClient from '../utils/HttpClient';
import { storageKeys } from '../constants/storage';
import { loginSuccessAction } from '../modules/auth/actions';
import { objectToQuery } from '../utils/Utils';
import { Outlet, useLocation, useNavigate } from 'react-router'
import { Link } from 'react-router-dom'
import { FaTwitter } from "react-icons/fa";
import { LuHistory } from "react-icons/lu";
import { RiFileUserFill, RiInstagramFill, RiWechatFill, RiSearchLine, RiUserFill, RiStarLine, RiHeartLine, RiCheckLine, RiUserLine, RiShoppingCartLine, RiFileListLine } from "react-icons/ri";
import { FaFacebook, FaYoutube, FaArrowUp, FaChevronDown } from "react-icons/fa6";
import { MdOutlineLogout } from "react-icons/md";
import { IoMdMenu } from "react-icons/io";
import MenuDrawer from '../components/MenuDrawer';
import { connect, useSelector, useDispatch } from 'react-redux';
import { IPAD, MOBILE, PC } from '../constants/ConstantsKey';
import { CHANGE_SCREEN } from '../global/ActionsPath';
import { Z_HEADER } from '../constants/ZIndex';
import { FloatButton, QRCode, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import profile from "../assets/images/no-profile.png";
import AuthModal from '../components/auth/AuthModal';
import { handleLogout } from '../utils/storage';
import CheckLogin from '../components/auth/CheckLogin';
import logoQrCode from '../assets/images/logoQRCode.png'
import GlobalSearchModal from '../components/GlobalSearchModal';
import PopupAdModal from '../components/PopupAdModal';
import { fetchCartCountRequest } from '../modules/shop/actions';
import SwitchLang from './SwitchLang';
import EventFlagIcon from '../assets/icons/EventFlag';

const REDIRECT_STORAGE_KEY = 'ESI_REDIRECT_URL';

const getSafeReturnUrl = (url) => {
  if (typeof url === 'string' && url.startsWith('/') && !url.startsWith('//')) {
    return url;
  }
  return null;
};

function DefaultLayout(props) {
  const { responsive, changeScreen } = props;
  const { t } = useTranslation();
  const menuDrawer = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const authModalRef = useRef()
  const user = useSelector((state) => state.authReducer);
  let token = user && user?.token ? user?.token : null;
  const isRegistered = Boolean(token && user?.user?.completedTS);
  const cart = useSelector((state) => state.shop.cart);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const dispatch = useDispatch();

  const handleAuthSuccess = useCallback(() => {
    let returnUrl = null;
    try {
      const stored = sessionStorage.getItem(REDIRECT_STORAGE_KEY);
      sessionStorage.removeItem(REDIRECT_STORAGE_KEY);
      returnUrl = getSafeReturnUrl(stored);
    } catch {}

    if (returnUrl) {
      navigate(returnUrl, { replace: true });
    }
  }, [navigate]);

  const handleAuthModalClose = useCallback(() => {
    try {
      sessionStorage.removeItem(REDIRECT_STORAGE_KEY);
    } catch {}
  }, []);

  useEffect(() => {
    const rawReturnUrl = location.state?.returnUrl;
    const safeUrl = getSafeReturnUrl(rawReturnUrl);

    if (safeUrl) {
      try {
        sessionStorage.setItem(REDIRECT_STORAGE_KEY, safeUrl);
      } catch {}
    }
  }, [location.state?.returnUrl]);

  useEffect(() => {
    if (!location.state?.openLogin || token) return;

    const { openLogin, ...remainingState } = location.state;
    navigate(location.pathname + location.search, {
      replace: true,
      state: Object.keys(remainingState).length > 0 ? remainingState : undefined,
    });

    if (authModalRef.current) {
      authModalRef.current.open();
      return;
    }

    const timer = setTimeout(() => {
      authModalRef.current?.open();
    }, 100);

    return () => clearTimeout(timer);
  }, [location.state, location.pathname, location.search, token, navigate]);

  useEffect(() => {
    const fetchCartCount = async () => {
      if (!token) return;
      dispatch(fetchCartCountRequest());
    };
    fetchCartCount();
  }, [token, location?.pathname]);

  const cartItemCount = cart?.totalQty ? (cart.totalQty || 0) : 0;

  const listMenu = [
    {
      link: "",
      label: t("text_homepage")
    },
    {
      link: "/news",
      label: t("menu_news"),
    },
    {
      link: "/education",
      label: t("menu_education"),
    },
    {
      link: "/product-knowledge",
      label: t("category_product"),
      dropdown: [
        { label: t("menu_product_knowledge"), link: '/product-knowledge' },
        { label: t("menu_buy_product"), link: '/product' }
      ]
    },
    {
      link: "/fashion",
      label: t("menu_fashion"),
      dropdown: [
        { label: t("menu_theme"), link: '/fashion/detail' },
        { label: t("menu_creative"), link: '/gallery/detail' }
      ]
    },
    {
      link: "/magazine",
      label: t("menu_magazine"),
    },
  ];

  const firstColumn = listMenu.slice(0, 3);
  const secondColumn = listMenu.slice(3);

  useEffect(() => {
    //Follow Tailwind Responsive Structure
    const handleResize = () => {
      if (window.innerWidth && window.innerWidth <= 639) {
        if (responsive.screen !== MOBILE) {
          changeScreen(MOBILE);
        }
      } else if (window.innerWidth && window.innerWidth <= 1023) {
        if (responsive.screen !== IPAD) {
          changeScreen(IPAD);
        }
      } else {
        changeScreen(PC);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [responsive, changeScreen]);

  const prevPathnameRef = useRef(location.pathname);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (prevPathnameRef.current !== location.pathname) {
      prevPathnameRef.current = location.pathname;
      if (typeof window !== 'undefined' && window.speechSynthesis) {
        try {
          window.speechSynthesis.cancel();
        } catch {}
      }
    }
  }, [location.pathname]);

  const [dropdownKey, setDropdownKey] = useState(Date.now());

  const goToPage = async (url) => {
    setDropdownKey(Date.now());
    navigate(url);
  }

  const [technicalCategory, setTechnicalCategory] = useState([
    {
      name: "menu_tech_showcase",
      value: "技术展示"
    },
    {
      name: "menu_trivia",
      value: "冷知识"
    }
  ]);

  useEffect(() => {
    if (token) {
      httpClient.get(PROFILE_INFO_URL)
        .then(res => {
          const member = res?.data?.member || res?.data?.data;
          if (member) {
            const existingUser = user?.user || {};
            const mergedUser = {
              ...existingUser,
              ...member,
              email: member.email || existingUser.email || '',
              phone: member.phone || existingUser.phone || null
            };
            dispatch(loginSuccessAction({ token, user: mergedUser, photo: mergedUser?.picUrl }));
            localStorage.setItem(storageKeys.USER, JSON.stringify(mergedUser));
            if (!mergedUser?.completedTS) {
              authModalRef.current?.open("REGISTER");
            } else {
              authModalRef.current?.close();
            }
          } else if (!user?.user?.completedTS) {
            authModalRef.current?.open("REGISTER");
          }
        })
        .catch(() => {
          if (!user?.user?.completedTS) {
            authModalRef.current?.open("REGISTER");
          }
        });
    }
  }, [token]);

  const isHomeActive = location.pathname === '/';
  const isNewsActive = location.pathname.startsWith('/news');
  const isFashionActive = location.pathname.startsWith('/fashion') || location.pathname.startsWith('/gallery');
  const isEducationActive = location.pathname.startsWith('/education') || location.pathname.startsWith('/online-class') || location.pathname.startsWith('/technical');
  const isProductActive = location.pathname.startsWith('/product');
  const isMagazineActive = location.pathname.startsWith('/magazine');

  return (
    <div className='esi-container'>
      <CheckLogin />
      <div className={`esi-header`} style={{ zIndex: Z_HEADER }}>
        <div className='esi-std-container h-full flex justify-between items-center px-0 sm:px-0'>
          <div className='flex items-center flex-shrink-0'>
            <img alt='ESI-Logo' role='button' src={BASE_URL + "/logo.svg"} onClick={() => { navigate("/") }} className='esi-logo' />
          </div>
          <div className='hidden lg:flex items-center justify-end gap-10 h-full flex-1'>
            {isRegistered ? (
              /* Logged In Navigation Links */
              <div className='flex items-center justify-center gap-[1rem] sm:gap-[1.5rem] md:gap-[2rem] h-full mx-auto div-header'>
                {/* 展会与资讯 */}
                <Link to="/" className={`esi-menu relative h-full flex items-center px-1 ${isHomeActive ? "active" : ""}`}>
                  {t("text_homepage")}
                  {isHomeActive && (
                   <div className="absolute bottom-2 left-0 right-0 h-[3px] bg-gradient-to-r from-[#50c7f8] via-[#7887fd] to-[#df97fb] rounded-full" />
                  )}
                </Link>
                <Link to="/news" className={`esi-menu relative h-full flex items-center px-1 ${isNewsActive ? "active" : ""}`}>
                  {t("menu_news")}
                  {isNewsActive && (
                   <div className="absolute bottom-2 left-0 right-0 h-[3px] bg-gradient-to-r from-[#50c7f8] via-[#7887fd] to-[#df97fb] rounded-full" />
                  )}
                </Link>

                {/* 型尚 Dropdown */}
                <div className="drop-cus h-full flex items-center">
                  <span className={`esi-menu relative h-full flex items-center gap-1 px-1 cursor-pointer ${isFashionActive ? "active" : ""}`} onClick={() => goToPage('/fashion')}>
                    {t("menu_fashion")}
                    <FaChevronDown className="text-[10px] opacity-75 mt-0.5" />
                    {isFashionActive && (
                     <div className="absolute bottom-2 left-0 right-0 h-[3px] bg-gradient-to-r from-[#50c7f8] via-[#7887fd] to-[#df97fb] rounded-full" />
                    )}
                  </span>
                  <div className="dropdown-menu-custom">
                    <div className={`dropdown-item ${location.pathname.startsWith('/fashion/detail') ? 'active' : ''}`} onClick={() => goToPage('/fashion/detail')}>{t("menu_theme")}</div>
                    <div className={`dropdown-item ${location.pathname.startsWith('/gallery/detail') ? 'active' : ''}`} onClick={() => goToPage('/gallery/detail')}>{t("menu_creative")}</div>
                  </div>
                </div>

                {/* 技术与教育 Dropdown */}
                <div className="drop-cus h-full flex items-center">
                  <span className={`esi-menu relative h-full flex items-center gap-1 px-1 cursor-pointer ${isEducationActive ? "active" : ""}`} onClick={() => goToPage('/education')}>
                    {t("menu_tech_edu")}
                    <FaChevronDown className="text-[10px] opacity-75 mt-0.5" />
                    {isEducationActive && (
                     <div className="absolute bottom-2 left-0 right-0 h-[3px] bg-gradient-to-r from-[#50c7f8] via-[#7887fd] to-[#df97fb] rounded-full" />
                    )}
                  </span>
                  <div className="dropdown-menu-custom">
                    <div className={`dropdown-item ${location.pathname.startsWith('/online-class') ? 'active' : ''}`} onClick={() => goToPage('/online-class')}>{t("menu_online_class")}</div>
                    {technicalCategory.map((category) => {
                      const isCatActive = decodeURIComponent(location.pathname).includes(category.value);
                      return (
                        <div
                          key={category.value}
                          className={`dropdown-item ${isCatActive ? 'active' : ''}`}
                          onClick={() => goToPage(`/technical/detail/${category.value}`)}
                        >
                          {t(category.name)}
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* 产品 Dropdown */}
                <div className="drop-cus h-full flex items-center">
                  <span
                    className={`esi-menu relative h-full flex items-center gap-1 px-1 cursor-pointer ${isProductActive ? "active" : ""}`}
                    onClick={() => goToPage('/product-knowledge')}
                  >
                    {t("category_product")}
                    <FaChevronDown className="text-[10px] opacity-75 mt-0.5" />
                    {isProductActive && (
                     <div className="absolute bottom-2 left-0 right-0 h-[3px] bg-gradient-to-r from-[#50c7f8] via-[#7887fd] to-[#df97fb] rounded-full" />
                    )}
                  </span>
                  <div className="dropdown-menu-custom">
                    <div 
                      className={`dropdown-item ${location.pathname.startsWith('/product-knowledge') ? 'active' : ''}`}
                      onClick={() => goToPage('/product-knowledge')}
                    >
                      {t("menu_product_knowledge")}
                    </div>
                    <div 
                      className={`dropdown-item ${location.pathname.startsWith('/product') && !location.pathname.startsWith('/product-knowledge') ? 'active' : ''}`}
                      onClick={() => goToPage('/product')}
                    >
                      {t("menu_buy_product")}
                    </div>
                  </div>
                </div>

                {/* 杂志订阅 */}
                <Link to="/magazine" className={`esi-menu relative h-full flex items-center px-1 ${isMagazineActive ? "active" : ""}`}>
                  {t("menu_magazine")}
                  {isMagazineActive && (
                   <div className="absolute bottom-2 left-0 right-0 h-[3px] bg-gradient-to-r from-[#50c7f8] via-[#7887fd] to-[#df97fb] rounded-full" />
                  )}
                </Link>
              </div>
            ) : null}

            {/* Right Section: Search, Cart & Profile Avatar/Login Button */}
            <div className="flex items-center gap-6">
              {/* <RiSearchLine 
                className="text-xl text-gray-700 cursor-pointer hover:text-black transition-colors" 
                onClick={() => setSearchModalOpen(true)}
              /> */}
              {
                isRegistered &&
                <div className="relative cursor-pointer" onClick={() => goToPage('/cart')}>
                  <RiShoppingCartLine className="text-xl text-gray-700 hover:text-black transition-colors" />
                  {cartItemCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-[#e2005a] text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full flex items-center justify-center min-w-[16px] h-[16px]">
                      {cartItemCount}
                    </span>
                  )}
                </div>
              }
              <SwitchLang {...props} />
              {isRegistered ? (
                /* Profile Dropdown */
                <div key={dropdownKey} className="drop-cus nav-item position-relative py-2">
                  {user?.user?.picUrl ? (
                    <img
                      src={user.user.picUrl}
                      alt="profile"
                      className="w-9 h-9 rounded object-cover border border-[#6b8cff]/40 cursor-pointer hover:border-[#6b8cff] transition-all"
                    />
                  ) : (
                    <div className="w-9 h-9 rounded bg-gradient-to-b from-[#1c2759] to-[#0b1236] border border-[#6b8cff]/40 flex items-center justify-center cursor-pointer shadow-md hover:border-[#6b8cff] transition-all">
                      <RiUserFill className="text-white text-lg" />
                    </div>
                  )}

                  <div className="dropdown-menu-custom">
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/fav-magazine/`)}>
                      <RiStarLine className="text-[17px]" />
                      <span>{t("text_fav_mazagine")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/like-magazine/`)}>
                      <RiHeartLine className="text-[17px]" />
                      <span>{t("text_like_mazagine")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/like-course/`)}>
                      <RiHeartLine className="text-[17px]" />
                      <span>{t("text_like_course")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/purchased-course/`)}>
                      <RiCheckLine className="text-[17px]" />
                      <span>{t("text_purchase_course")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/my-orders`)}>
                      <RiFileListLine className="text-[17px]" />
                      <span>{t("text_my_order")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/my-activities`)}>
                      <EventFlagIcon className="text-[17px]" />
                      <span>{t("text_my_activities")}</span>
                    </div>
                    {/* <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/purchase-history`)}>
                      <LuHistory className="text-[17px]" />
                      <span>{t("text_purchase_history")}</span>
                    </div> */}
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/profiles/`)}>
                      <RiUserLine className="text-[17px]" />
                      <span>{t("text_profile")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3 border-t border-gray-100" onClick={() => {
                      setDropdownKey(Date.now());
                      handleLogout();
                      navigate('/');
                    }}>
                      <MdOutlineLogout className="text-[17px]" />
                      <span>{t("text_logout")}</span>
                    </div>
                  </div>
                </div>
              ) : (
                  <div className='p-[2px] bg-gradient-to-r from-[#50c7f8] via-[#7887fd] to-[#df97fb] shadow-md'>
                    <button onClick={() => authModalRef.current.open()} className='flex items-center gap-2 px-5 py-2.5 text-white bg-gradient-to-r from-[#21163e] to-[#252554] hover:opacity-90 transition-all h-full w-full'>
                      <span className='text-sm tracking-widest'>{t("text_login_reg")}</span>
                    </button>
                  </div>
              )}
            </div>
          </div>
          <div className='block lg:hidden flex-shrink-0'>
            <div className='flex items-center gap-2 xs:gap-2.5 sm:gap-3.5 flex-shrink-0 esi-header-actions'>
              {/* <RiSearchLine 
                className="text-[22px] text-gray-700 cursor-pointer hover:text-black transition-colors" 
                onClick={() => setSearchModalOpen(true)}
              /> */}
              {
                isRegistered &&
                <div className="relative cursor-pointer flex-shrink-0" onClick={() => goToPage('/cart')}>
                  <RiShoppingCartLine className="text-[20px] sm:text-[22px] text-gray-700 hover:text-black transition-colors" />
                  {cartItemCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-[#e2005a] text-white text-[10px] font-bold px-1 py-0.5 rounded-full flex items-center justify-center min-w-[15px] h-[15px]">
                      {cartItemCount}
                    </span>
                  )}
                </div>
              }
              <SwitchLang {...props} />
              {isRegistered && (
                <IoMdMenu className='w-[22px] h-[22px] sm:w-[25px] sm:h-[25px] text-gray-700 flex-shrink-0 cursor-pointer' onClick={() => menuDrawer.current?.open()} />
              )}
              {isRegistered ? (
                /* Mobile Avatar Dropdown */
                <div key={dropdownKey} className="drop-cus nav-item position-relative flex-shrink-0">
                  {user?.user?.picUrl ? (
                    <img
                      src={user.user.picUrl}
                      alt="profile"
                      className="w-7 h-7 sm:w-8 sm:h-8 rounded object-cover border border-[#6b8cff]/40 cursor-pointer hover:border-[#6b8cff] transition-all"
                    />
                  ) : (
                    <div className="w-7 h-7 sm:w-8 sm:h-8 rounded bg-gradient-to-b from-[#1c2759] to-[#0b1236] border border-[#6b8cff]/40 flex items-center justify-center cursor-pointer shadow-md hover:border-[#6b8cff] transition-all">
                      <RiUserFill className="text-white text-sm sm:text-base" />
                    </div>
                  )}

                  <div className="dropdown-menu-custom">
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/fav-magazine/`)}>
                      <RiStarLine className="text-[17px]" />
                      <span>{t("text_fav_mazagine")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/like-magazine/`)}>
                      <RiHeartLine className="text-[17px]" />
                      <span>{t("text_like_mazagine")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/like-course/`)}>
                      <RiHeartLine className="text-[17px]" />
                      <span>{t("text_like_course")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/purchased-course/`)}>
                      <RiCheckLine className="text-[17px]" />
                      <span>{t("text_purchase_course")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/my-orders`)}>
                      <RiFileListLine className="text-[17px]" />
                      <span>{t("text_my_order")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/my-activities`)}>
                      <EventFlagIcon className="text-[17px]" />
                      <span>{t("text_my_activities")}</span>
                    </div>
                    {/* <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/purchase-history`)}>
                      <LuHistory className="text-[17px]" />
                      <span>{t("text_purchase_history")}</span>
                    </div> */}
                    <div className="dropdown-item flex items-center gap-3" onClick={() => goToPage(`/profiles/`)}>
                      <RiUserLine className="text-[17px]" />
                      <span>{t("text_profile")}</span>
                    </div>
                    <div className="dropdown-item flex items-center gap-3 border-t border-gray-100" onClick={() => {
                      setDropdownKey(Date.now());
                      handleLogout();
                      navigate('/');
                    }}>
                      <MdOutlineLogout className="text-[17px]" />
                      <span>{t("text_logout")}</span>
                    </div>
                  </div>
                </div>
              ) : (
                /* Mobile Login Button */
                <button
                  onClick={() => authModalRef.current.open()}
                  className="bg-gradient-to-r from-[#1e295d] to-[#0d163d] text-white text-xs font-semibold px-2.5 sm:px-3 py-1.5 rounded border border-[#6b8cff]/50 hover:border-[#6b8cff] transition-all cursor-pointer shadow-sm whitespace-nowrap flex-shrink-0"
                >
                  {t("text_login")}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='esi-content'>
        <Outlet />
      </div>
      {location.pathname === "/" && (
        <div className="bg-white pt-12 pb-0 flex flex-col items-center select-none">
          <div className="text-center mb-8 px-4">
            <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight mb-3">
              {t("h1_contactUs")}
            </h2>
            <p className="text-sm text-gray-500 max-w-sm sm:max-w-lg mx-auto leading-relaxed">
              {t("text_contact_us")}
            </p>
          </div>

          <div className="relative w-[90%] max-w-[580px] p-6 sm:p-8 bg-gradient-to-r from-[#6b8cff] to-[#59e3ff] text-white shadow-xl hover:shadow-2xl transition-all duration-300 -mb-24 z-10 flex flex-col justify-center items-center">
            <div className="flex flex-col gap-6 w-full max-w-[480px]">
              {/* Email Row */}
              <div className="flex items-center gap-4">
                <span className="text-base sm:text-lg font-bold min-w-[70px] shrink-0 opacity-90">{t("text_email")}</span>
                <a href="mailto:support@esiproonline.com" className="text-base sm:text-lg font-semibold hover:underline opacity-95 tracking-wide">
                  support@esiproonline.com
                </a>
              </div>

              {/* WeChat Row */}
              <div className="flex items-start gap-4">
                <span className="text-base sm:text-lg font-bold min-w-[70px] shrink-0 opacity-90 mt-2">{t("text_wechat_id")}</span>
                <div className="flex items-end gap-5 flex-wrap sm:flex-nowrap">
                  {/* Scanner Frame */}
                  <div className="relative p-3.5 flex items-center justify-center select-none">
                    {/* WeChat Icon sitting on top border */}
                    <div className="absolute -top-1 left-1/2 -translate-x-1/2 z-20 text-white">
                      <RiWechatFill className="text-lg" />
                    </div>

                    {/* Scanner Corner Brackets */}
                    <div className="absolute top-0 left-0 w-3.5 h-3.5 border-t-[2px] border-l-[2px] border-white rounded-tl-[3px]"></div>
                    <div className="absolute top-0 right-0 w-3.5 h-3.5 border-t-[2px] border-r-[2px] border-white rounded-tr-[3px]"></div>
                    <div className="absolute bottom-0 left-0 w-3.5 h-3.5 border-b-[2px] border-l-[2px] border-white rounded-bl-[3px]"></div>
                    <div className="absolute bottom-0 right-0 w-3.5 h-3.5 border-b-[2px] border-r-[2px] border-white rounded-br-[3px]"></div>

                    {/* QR Code */}
                    <img src={logoQrCode} alt='Logo QR code' width={150} />
                  </div>

                  {/* WeChat Badge */}
                  <div className="flex items-center gap-2.5 text-white font-semibold mb-1">
                    <div className="bg-[#52c41a] p-1.5 rounded-lg flex items-center justify-center text-white w-8 h-8 shadow-sm">
                      <RiWechatFill className="text-xl" />
                    </div>
                    <span className="text-sm sm:text-base tracking-wide opacity-90">{t("text_scan_follow")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className='esi-footer h-auto bg-[#1a1a1a]'>
        <div className={`esi-std-container h-full grid grid-cols-6 pb-[30px] ${location.pathname === "/" ? "pt-[150px]" : "pt-[30px]"}`}>
          <div className='md:max-lg:pr-3 lg:max-w-[440px] col-span-6 md:col-span-3 lg:col-span-2 flex flex-col'>
            <div className='flex items-center max-sm:justify-center'>
              <img alt='ESI-Logo' role='button' onClick={() => { navigate("/") }} src={BASE_URL + "/logo.svg"} className='esi-logo brightness-0 invert' />
            </div>
            <div>
              <div className='social-media max-sm:justify-center'>
                <a target="_blank" href='#'><FaTwitter className='social-media-icon !text-white hover:!text-[#e50a47]' /></a>
                <a target="_blank" href='#'><RiInstagramFill className='social-media-icon !text-white hover:!text-[#e50a47]' /></a>
                <a target="_blank" href='#'><FaFacebook className='social-media-icon !text-white hover:!text-[#e50a47]' /></a>
                <a target="_blank" href='#'><FaYoutube className='social-media-icon !text-white hover:!text-[#e50a47]' /></a>
              </div>
              <div className='footer-content !text-[#999999]'>
                {t("footer_content")}
              </div>
            </div>
          </div>
          <div className='hidden lg:block lg:col-span-1'></div>
          <div className='col-span-6 md:col-span-3 mt-8 md:mt-0 flex justify-between md:justify-around flex-wrap gap-6 md:gap-0'>
            {/* <div className='col-span-1'>
              <div className='footer-submenu-container'>
                <div className='footer-submenu-title !text-white'>{t("Most popular sections")}</div>
                {
                  listMenu.map((item) => {
                    return <Link to={item.link} key={item.link} className={`footer-submenu !text-[#999999] hover:!text-white ${item.className} ${location.pathname === item.link && "activeNew"}`}>{item.label}</Link>
                  })
                }
              </div>
            </div> */}
            <div className="col-span-1">
              <div className="footer-submenu-container">
                <div className="footer-submenu-title !text-white">
                  {t("Most popular sections")}
                </div>

                <div className="grid grid-cols-2 gap-12">
                  <div className="flex flex-col">
                    {firstColumn.map((item) => (
                      <Link
                        key={item.link}
                        to={item.link}
                        className={`footer-submenu !text-[#999999] hover:!text-white pb-5 ${location.pathname === item.link ? "activeNew" : ""
                          }`}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>

                  <div className="flex flex-col" style={{marginLeft:"1rem"}}>
                    {secondColumn.map((item) => (
                      <Link
                        key={item.link}
                        to={item.link}
                        className={`footer-submenu !text-[#999999] hover:!text-white pb-5 ${location.pathname === item.link ? "activeNew" : ""
                          }`}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className='col-span-1'>
              <div className='footer-submenu-container'>
                <div className='footer-submenu-title !text-white'>{t("Most popular sections")}</div>
                <Link className='footer-submenu !text-[#999999] hover:!text-white'>{t("Hair collection")}</Link>
                <Link className='footer-submenu !text-[#999999] hover:!text-white'>{t("BREAKING NEWS")}</Link>
                <Link className='footer-submenu !text-[#999999] hover:!text-white'>{t("EDITIONSUK")}</Link>
                <Link className='footer-submenu !text-[#999999] hover:!text-white'>{t("INSPIRATION")}</Link>
              </div>
            </div> */}
          </div>
        </div>
        {/* Bottom full-width gradient copyright bar */}
        <div className="w-full py-4 px-4 bg-gradient-to-r from-[#50c7f8] via-[#7887fd] to-[#df97fb] text-white text-center text-[10px] sm:text-xs font-semibold tracking-wider leading-relaxed flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
          <span>{t("text_copyright")}</span>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-blue opacity-95 hover:opacity-100 transition-opacity"
          >
            {t("text_icp")}
          </a>
        </div>
      </div>
      <FloatButton.BackTop
        icon={<FaArrowUp style={{ color: "var(--primary-button-text-color)" }} />}
        className='esi-floating-button'
        style={{
          color: "white",
          backgroundColor: "black"
        }}
      />
      <MenuDrawer ref={menuDrawer}
        authModalRef={authModalRef}
        listMenu={listMenu} t={t} handleLogout={handleLogout} goToPage={goToPage} user={user}
        technicalCategory={technicalCategory} />
      <AuthModal ref={authModalRef} onAuthSuccess={handleAuthSuccess} onClose={handleAuthModalClose} />
      <GlobalSearchModal 
        open={searchModalOpen}
        onCancel={() => setSearchModalOpen(false)}
      />
      <PopupAdModal />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => ({
  changeScreen: (payload) => dispatch({ type: CHANGE_SCREEN, payload: payload }),
});

const mapStateToProps = (state) => ({ responsive: state.responsive })

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);